import { Box, styled, Typography } from "@mui/material";
import Image from "next/image";
import React, { useContext } from "react";
import { Autoplay, Pagination } from "swiper/modules";
// Import Swiper styles
import "swiper/css";
import "swiper/css/pagination";
import { Swiper, SwiperSlide } from "swiper/react";

import BoltRoundedIcon from "@mui/icons-material/BoltRounded";
import { primary } from "../../../constants/theme";
import { Context } from "../../../context/context";
import { sendAnalytics } from "../../../utils/analyticsCommon";
import { useMobile } from "../../../utils/findViewport";

const CustomVehicleSpecificUseSwiper = styled(Box)(
  ({ theme, ignorepadding }) => ({
    width: "82%",
    margin: "26px auto",
    ".image-section": {
      objectFit: "contain",
      width: "100% !important",
      position: "relative !important",
    },
    ".image-section-2": {
      objectFit: "contain",
      // width: "100% !important",
      position: "relative !important",
    },

    [theme.breakpoints.down("sm")]: {
      width: "100%",
      padding: ignorepadding ? "0px" : "0px 0px 20px 20px",
      margin: "0px",
    },
  })
);

const VehicleSpecificUseSwiper = ({
  data,
  headerInfo,
  addtionalInfo,
  slidePerView,
  isHeader,
  isTitle,
  ignorepadding,
  slideReq,
}) => {

  const isMobile = useMobile();

  const { showTestDriveDrawer } = useContext(Context);
  return (
    <CustomVehicleSpecificUseSwiper ignorepadding={ignorepadding}>
      <Box>
        <Box
          style={{
            display: isHeader === false ? "none" : "flex",
            justifyContent: "start",
            alignItems: "center",
            marginBottom: "10px",
          }}
        >
          {/* <Image
            src={imagesList.foldOne}
            width="70"
            height={"70"}
            alt="Benefits with Turno"
            className={"image-section-2"}
            effect="opacity"
          /> */}
          <Box>
            <Typography
              style={{
                fontSize: "24px",
                fontWeight: "700",
                // display: "flex",
                // alignItems: "center",
              }}
              onClick={() => {
                showTestDriveDrawer();
                sendAnalytics("turno_clicked_by_swiper_title", {}, "en");
              }}
            >
              {" "}
              <div dangerouslySetInnerHTML={{ __html: `${headerInfo}` }} />
            </Typography>

            {addtionalInfo && (
              <Typography
                style={{
                  fontSize: "24px",
                  fontWeight: "700",
                  color: primary?.mainGreen,
                  // display: "flex",
                  // alignItems: "center",
                }}
                onClick={() => {
                  showTestDriveDrawer();
                  sendAnalytics("turno_clicked_by_swiper_title", {}, "en");
                }}
              >
                <BoltRoundedIcon
                  sx={{
                    transform: { xs: "unset", md: "scale(2)" },
                    paddingTop: "3px",
                  }}
                />
                {addtionalInfo}
              </Typography>
            )}
          </Box>
        </Box>

        <Box>
          <Swiper
            slidesPerView={isMobile ? slideReq ?? 1.2 : 4}
            spaceBetween={isMobile ? 10 : 20}
            // centeredSlides={true}
            pagination={false}
            loop={true}
            // autoplay={{
            //   delay: 4500,
            //   disableOnInteraction: false,
            // }}
            modules={[Pagination]}
            className="swiper-turno-india"
          >
            {data?.map((data, index) => {
              return (
                <SwiperSlide key={index}>
                  <Box>
                    <Box>
                      {" "}
                      <Image
                        src={data?.imageName}
                        alt="Benefits with Turno"
                        className={"image-section"}
                        fill
                        effect="opacity"
                        loading="lazy"
                      />
                    </Box>
                    <Box>
                      <Typography
                        style={{
                          fontSize: "12px",
                          display: isTitle === false ? "none" : "flex",
                        }}
                      >
                        {data?.title}
                      </Typography>
                    </Box>
                  </Box>
                </SwiperSlide>
              );
            })}
          </Swiper>
        </Box>
      </Box>
    </CustomVehicleSpecificUseSwiper>
  );
};

export default VehicleSpecificUseSwiper;
